import dayjs from "dayjs";
import { OrderDetails } from "hooks/OrderManagement/useOrders";
import { Status } from "../Components/Status";

type StatusLogsProps = {
  data: OrderDetails;
};
export const StatusLogs = ({ data }: StatusLogsProps) => {
  if (data.statusLogs.length === 0 || !data.statusLogs) return null;

  return (
    <div className="">
      <h3 className="text-lg font-semibold mb-2">Activity Logs</h3>
      <ol className="border-l border-primary/40">
        {data.statusLogs.map((statusLog) => (
          <li key={statusLog.id}>
            <div className="flex-start flex items-center pt-3">
              <div className="-ml-[5px] mr-3 h-[9px] w-[9px] rounded-full bg-primary/80"></div>
              {statusLog?.createdAt && (
                <p className="text-sm text-primary-foreground">
                  {dayjs(statusLog.createdAt).format("D MMM YYYY, h:mm A")}
                </p>
              )}
              <Status
                value={statusLog.status}
                className="text-xs ml-auto p-1"
              />
            </div>
            <div className="mb-2 ml-4 mt-2">
              {statusLog.note && (
                <h4 className="text-base font-semibold">{statusLog.note}</h4>
              )}
              <p className="text-grey text-sm">
                By {statusLog.admin?.firstName}
              </p>
            </div>
          </li>
        ))}
      </ol>
    </div>
  );
};
